import React from 'react';
import { Home } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { SectionCard, SectionFields, SectionFieldConfig, SectionFieldsProps, SectionTone } from './SectionCard';

/** Justification textarea every plan has (`homeboundJustification`). */
export const homeboundJustificationField = (overrides: Partial<SectionFieldConfig> = {}): SectionFieldConfig => ({
  key: 'homeboundJustification', label: 'Homebound Justification', kind: 'textarea', rows: 4, wide: true, ...overrides,
});

interface HomeboundSectionProps extends SectionFieldsProps {
  title: string;
  /** The plan's homebound fields (indicators, status, justification), in display order */
  fields: SectionFieldConfig[];
  columns?: 1 | 2 | 3;
  tone?: SectionTone;
  icon?: LucideIcon | null;
  collapsed?: boolean;
  onToggle?: () => void;
}

/**
 * Phase 19 F25: homebound status (CMS-485). The plans record it differently (RN/PT boolean
 * indicators, OT a status choice, ST a criteria list), so each plan passes its own field list;
 * the keys are the plan's own formData keys.
 */
const HomeboundSection: React.FC<HomeboundSectionProps> = ({
  title, fields, columns = 1, tone = 'purple', icon = Home, collapsed = false, onToggle, ...fieldProps
}) => (
  <SectionCard title={title} icon={icon} tone={tone} collapsed={collapsed} onToggle={onToggle}>
    <SectionFields fields={fields} columns={columns} {...fieldProps} />
  </SectionCard>
);

export default HomeboundSection;
